import React, { useState, useEffect, useCallback, useRef } from 'react';

import { useNavigate } from 'react-router-dom';


function Form() {
    const navigate = useNavigate();


    return (
        <div>
            <h1></h1>
        </div>
      
    );
};

export default Form;